import styles from './BrandSpotlight.module.scss'
import BrandChip from '../Brands/BrandChip'
import classNames from 'classnames'

export default function BrandSpotlight({ brands }) {
  return (
    <section className={styles.wrapper}>
      <div className="container">
        <header>
          <h2 className={classNames('h1', styles.heading)}>Brand spotlight</h2>
          <div>Products selected for this project</div>
        </header>
        <div className={styles.brandsContainer}>
          {brands.map((brand) => (
            <div className={styles.brandPanel} key={brand.slug}>
              <BrandChip
                src={brand.logo.src}
                bgFill={brand.logo.bleedColor}
                name={brand.name}
                // href={`/brands/${brand.slug}`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
